import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { http } from "../../utils";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks";

function fetchHospitalReview(params, id, sort) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL(
    `/admin/product-reviews?hospitalId=${id}`,
    baseUrl
  );

  if (params.enrollmentStatus) {
    endpointUrl.searchParams.append("enrollmentStatus", params.enrollmentStatus);
  }

  if (params.division) {
    endpointUrl.searchParams.append("division", params.division);
  }

  if (params.productGroupName) {
    endpointUrl.searchParams.append("productGroupName", params.productGroupName);
  }

  if (sort.orderBy) {
    endpointUrl.searchParams.append("orderBy", sort.orderBy);
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.contents) {
    endpointUrl.searchParams.append("contents", params.contents);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useHospitalReviewList(params = {}, id, sort = {}) {
  return usePaginationQuery(
    [
      "review",
      params.enrollmentStatus,
      params.division,
      params.productGroupName,
      sort.orderBy,
      params.from,
      params.to,
      params.contents,
    ],
    (paginationState) =>
      fetchHospitalReview({ ...params, ...paginationState }, id, sort)
  );
}
async function addHospitalReview(formData) {
  const data = await http(`/admin/review`, {
    data: formData,
  });
  return data;
}

export function useAddHospitalReview() {
  const queryClient = useQueryClient();

  return useMutation(addHospitalReview, {
    onSuccess: () => {
      queryClient.refetchQueries(["-review"]);
    },
  });
}

export function useUpdateReview() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/review/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        if (res !== undefined) {
          await queryClient.invalidateQueries(["review"]);
          setTimeout(() => {
            navigate("/bulletin-board/");
          }, 1500);
        }
      },
    }
  );
}

async function deleteHospitalReview(id) {
  const data = await http(`/admin/-review/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteHospitalReview() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteHospitalReview, {
    onSuccess: () => {
      queryClient.invalidateQueries(["-review"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

export async function fetchHospitalReviewDownload() {
  const { data } = await http(`/admin/review-download`, {
    responseType: "blob",
  });

  return data;
}

export function useHospitalReviewDownload() {
  const { data, ...raResult } = useQuery(["review-download"], () =>
    fetchHospitalReviewDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
